var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "is-flex is-align-items-center is-justify-content-flex-start",
      staticStyle: { gap: "8px", "flex-wrap": "wrap" },
    },
    [
      _c(
        "div",
        {
          staticClass: "is-flex is-align-items-center",
          staticStyle: { "flex-shrink": "0" },
        },
        [
          _vm._l(["en", "fr", "de_DE"], function (item) {
            return [
              _c(
                "button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.changeLocale(item)
                    },
                  },
                },
                [
                  item
                    ? _c("gb-flag", {
                        class: { "is-selected": item === _vm.locale },
                        attrs: {
                          code: _vm.getFlag(item),
                          size: "small",
                          iconPath: "/assets/img/flags/",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.settings.crud && _vm.settings.crud.mergeStatus
        ? _c(
            "div",
            {
              staticClass: "is-flex is-align-items-center",
              staticStyle: { gap: "4px", "flex-shrink": "0" },
            },
            [
              _c(
                "span",
                {
                  staticClass: "merge-status is-buspaket",
                  class: {
                    "is-inactive": _vm.sourceFilterValue !== "buspaket",
                  },
                  staticStyle: { cursor: "pointer" },
                  attrs: { title: "Buspaket/WE Tours" },
                  on: {
                    click: function ($event) {
                      _vm.sourceFilterValue = "buspaket"
                    },
                  },
                },
                [_vm._v("B")]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "merge-status is-welcome",
                  class: { "is-inactive": _vm.sourceFilterValue !== "welcome" },
                  staticStyle: { cursor: "pointer" },
                  attrs: { title: "Welcome Tours" },
                  on: {
                    click: function ($event) {
                      _vm.sourceFilterValue = "welcome"
                    },
                  },
                },
                [_vm._v("W")]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("email-template-select", {
        staticStyle: { "max-width": "350px", flex: "1", "min-width": "150px" },
        attrs: { "templates-filtered": _vm.templates },
        model: {
          value: _vm.templateSelected,
          callback: function ($$v) {
            _vm.templateSelected = $$v
          },
          expression: "templateSelected",
        },
      }),
      _vm._v(" "),
      _vm.templateSelected && _vm.templateSelected.variants.length > 0
        ? _c("multiselect", {
            staticStyle: {
              "max-width": "350px",
              flex: "1",
              "min-width": "150px",
            },
            attrs: {
              options: _vm.templateSelected.variants,
              label: "name",
              "custom-label": (variant) =>
                variant.personal
                  ? variant.name + " (meine Fassung)"
                  : variant.name,
              "track-by": "id",
              "max-height": 600,
            },
            model: {
              value: _vm.variantSelected,
              callback: function ($$v) {
                _vm.variantSelected = $$v
              },
              expression: "variantSelected",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.settings.emails.isFormal[_vm.emailType]
        ? _c(
            "toggle-switch",
            {
              staticClass: "mb-0",
              staticStyle: { "margin-right": "10px" },
              attrs: { "btn-style": "height: 35px" },
              model: {
                value: _vm.isFormal,
                callback: function ($$v) {
                  _vm.isFormal = $$v
                },
                expression: "isFormal",
              },
            },
            [
              _c("option", { domProps: { value: false } }, [_vm._v("Du")]),
              _vm._v(" "),
              _c("option", { domProps: { value: true } }, [_vm._v("Sie")]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button is-large is-icon",
          staticStyle: { height: "35px" },
          attrs: { title: "Template neu laden" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              return _vm.fillEmail.apply(null, arguments)
            },
          },
        },
        [_c("i", { staticClass: "material-icons" }, [_vm._v("loop")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }